import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppNavbar from "./components/AppNavbar";
import { RequireAuth, RequireRole } from "./routing/RequireAuth";
import AdminEnquiryDetailPage from "./pages/AdminEnquiryDetailPage";
import AllLeadsPage from "./pages/AllLeadsPage";
import BirthdayRemindersPage from "./pages/BirthdayRemindersPage";
import DashboardPage from "./pages/DashboardPage";
import EntryNewLeadPage from "./pages/EntryNewLeadPage";
import FollowUpPage from "./pages/FollowUpPage";
import LoginPage from "./pages/LoginPage";
import MasterPage from "./pages/MasterPage";
import PendingBalancesPage from "./pages/PendingBalancesPage";
import PublicEnquiryPage from "./pages/PublicEnquiryPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import WhatsAppRemindersPage from "./pages/WhatsAppRemindersPage";

export default function App() {
  return (
    <div className="min-vh-100 bg-light">
      <AppNavbar />
      <main className="app-main-content">
        <div className="container-fluid px-3 px-md-4 py-4">
        <Routes>
          <Route path="/" element={<Navigate to="/customer" replace />} />
          <Route path="/customer" element={<PublicEnquiryPage />} />
          <Route path="/enquiry" element={<PublicEnquiryPage />} />
          <Route path="/customer-form" element={<PublicEnquiryPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <RequireRole allow={["admin", "team_member"]}>
                  <DashboardPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/admin/enquiries/:id"
            element={
              <RequireAuth>
                <RequireRole allow={["admin"]}>
                  <AdminEnquiryDetailPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/master/work-types"
            element={
              <RequireAuth>
                <RequireRole allow={["admin"]}>
                  <MasterPage section="workTypes" />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/master/works"
            element={
              <RequireAuth>
                <RequireRole allow={["admin"]}>
                  <MasterPage section="works" />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/master/enquiry-statuses"
            element={
              <RequireAuth>
                <RequireRole allow={["admin"]}>
                  <MasterPage section="statuses" />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/master/users"
            element={
              <RequireAuth>
                <RequireRole allow={["admin"]}>
                  <MasterPage section="users" />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/entry/new-lead"
            element={
              <RequireAuth>
                <RequireRole allow={["admin", "team_member"]}>
                  <EntryNewLeadPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/entry/follow-up"
            element={
              <RequireAuth>
                <RequireRole allow={["admin", "team_member"]}>
                  <FollowUpPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/entry/all-leads"
            element={
              <RequireAuth>
                <RequireRole allow={["admin", "team_member"]}>
                  <AllLeadsPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/entry/whatsapp-reminders"
            element={
              <RequireAuth>
                <RequireRole allow={["admin", "team_member"]}>
                  <WhatsAppRemindersPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/entry/birthday-reminders"
            element={
              <RequireAuth>
                <RequireRole allow={["admin", "team_member"]}>
                  <BirthdayRemindersPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/entry/pending-balances"
            element={
              <RequireAuth>
                <RequireRole allow={["admin"]}>
                  <PendingBalancesPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/reports"
            element={
              <RequireAuth>
                <RequireRole allow={["admin", "team_member"]}>
                  <ReportsPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/settings"
            element={
              <RequireAuth>
                <RequireRole allow={["admin"]}>
                  <SettingsPage />
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route path="/admin" element={<Navigate to="/dashboard" replace />} />
          <Route path="/team" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/customer" replace />} />
        </Routes>
        </div>
      </main>
    </div>
  );
}
